import React, { useEffect, useState } from "react";
import { HeroInternas } from "../heroInternas/HeroInternas";
import { Search } from "./Search";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import renderHTML from "react-render-html";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        border: "none"
    },
    accordion: {
        backgroundColor: "#e2dfd5",
        boxShadow: "none",
        color: "#12472d",
        fontFamily: "'Montserrat', sans-serif",
        "&:before": {
            display: "none"
        }
    },
    accordionExpanded: {
        marginBottom: "16px !important"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightBold,
        color: "#12472d !important",
        fontFamily: "'Montserrat', sans-serif"
    },
    details: {
        fontFamily: "'Montserrat', sans-serif",
        color: "#12472d",
        "& *": {
            color: "#12472d",
            fontFamily: "'Montserrat', sans-serif"
        }
    }
}));

export const PreguntasFrecuentes = () => {
    let [question, setQuestion] = useState("");

    const classes = useStyles();

    const [preguntasFrecuentes, setPreguntasFrecuentes] = useState([]);

    useEffect(() => {
        fetch("/pregFreq")
            .then(res => res.json())
            .then(result => {
                if (result.estado !== 0) {
                    const orderedFaqs = result.sort((a, b) => a.order - b.order);
                    setPreguntasFrecuentes(orderedFaqs);
                }
            });
    }, []);

    if (preguntasFrecuentes.length !== 0) {
        preguntasFrecuentes.map(pregunta => {
            let desc = pregunta.descripcion.replaceAll("&nbsp;", " ");
            pregunta.newDescription = desc;
        });
    }

    const getPreguntaByQuery = (query = "") => {
        if (query === "") {
            return [];
        }

        const removeAccents = str => {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        };

        query = removeAccents(query.toLocaleLowerCase());
        const preguntas = preguntasFrecuentes.filter(pregunta =>
            removeAccents(pregunta.titulo.toLocaleLowerCase()).includes(query)
        );

        return preguntas;
    };

    let preguntas = getPreguntaByQuery(question);
    console.log(preguntas);

    return (
        <div className="flexible">
            <HeroInternas title="Preguntas frecuentes" />

            <div className="drop-container">
                {/* <p>a</p> */}
                <div className="drop">
                    <Search setQuestion={setQuestion} />
                    {preguntas.length == 0 ? (
                        question == "" ? (
                            preguntasFrecuentes.map(pregunta => (
                                <>
                                    <div
                                        className={classes.root}
                                        key={pregunta.id}
                                    >
                                        <Accordion
                                            className={classes.accordion}
                                            classes={{ expanded: classes.accordionExpanded }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon style={{ color: "#12472d" }} />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography className={classes.heading}>
                                                    {pregunta.titulo}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className={classes.details}>
                                                <Typography variant="h1" component="div">
                                                    {renderHTML(pregunta.newDescription)}
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                    <div className="separator--hor"></div>
                                </>
                            ))
                        ) : (
                            <p>No se encontraron resultados</p>
                        )
                    ) : (
                        preguntas.map(pregunta => (
                            <>
                                <div
                                    className={classes.root}
                                    key={pregunta.id}
                                >
                                    <Accordion
                                        className={classes.accordion}
                                        classes={{ expanded: classes.accordionExpanded }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon style={{ color: "#12472d" }} />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography className={classes.heading}>
                                                {pregunta.titulo}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.details}>
                                            <Typography variant="h1" component="div">
                                                {renderHTML(pregunta.newDescription)}
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                                <div className="separator--hor"></div>
                            </>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};
